export const DEFAULT_SEND_BUTTON_TEXT = 'Zapisz';

export const DEFAULT_THX_HEADER = 'ZOSTAŁ OSTATNI KROK!';

export const DEFAULT_THX_MESSAGE =
  'Wysłaliśmy do Ciebie e-mail z prośbą o potwierdzenie chęci zapisu.';

export const DEFAULT_THX_MESSAGE_SUFFIX = 'Kliknij przycisk w wiadomości, aby potwierdzić.';

export function getAgreeTestDriveMessage(campaignName: string, override?: string | null): string {
  if (override) return override;
  return `Chcę umówić się telefonicznie na jazdę testową samochodem ${campaignName}`;
}

export const CONSENT_NEWSLETTER_TEXT =
  'Chcę otrzymywać Newsletter od Volkswagen Group Polska Sp. z o.o. z wykorzystaniem adresu e-mail oraz pozostałych podanych przeze mnie Danych.*';

export const CONSENT_DIRECT_MARKETING_TEXT =
  'W ramach Newslettera zgadzam się na otrzymywanie od Volkswagen Group Polska Sp. z o.o. w/w informacji mogących stanowić informacje handlowe i marketingowe.*';

export const DEFAULT_RULES_PDF = '/brandportal/newsletter/rules/regulamin.pdf';

// `rulesPdf` from campaign config is already an absolute path (e.g.
// "/brandportal/newsletter/rules/<hash>.pdf") generated by the migration script — it must be
// used as-is, not re-prefixed, or the browser resolves it relative to the current page and
// doubles the path.
export function getRulesPdfPath(rulesPdf?: string | null): string {
  return rulesPdf || DEFAULT_RULES_PDF;
}

export const DEFAULT_BACKGROUND_IMAGE = '/brandportal/newsletter/images/desktop/new_bp_form_desktop.webp';

export const DEFAULT_MOBILE_IMAGE = '/brandportal/newsletter/images/mobile/new_bp_form_mobile.webp';
